import { createSelector } from 'reselect';
import { compose, get, getOr, compact, over } from 'lodash/fp';
import { DENSE_LIGHT_THEME } from '@optimus-web/theme';
import { getToken } from '@optimus-web/core';
import { getContainer } from '@mews-commander/legacy-app-instance';
import { moduleSelector } from '../module';

const EMPTY = {
    toDo: 0,
    missed: 0,
    done: 0,
    online: 0,
};
const ARRIVAL_KEYS = {
    toDo: 'ArrivalsRemaining',
    missed: 'NoShowPlural',
    done: 'ArrivalsDone',
    online: 'OnlineCheckedIn',
};
const DEPARTURE_KEYS = {
    toDo: 'DeparturesRemaining',
    missed: 'CheckOutMissed',
    done: 'DeparturesDone',
    online: 'OnlineCheckedOut',
};
const COLORS = {
    toDo: getToken('legacyTagBorderDenim')({ theme: DENSE_LIGHT_THEME }),
    missed: getToken('legacyTagBorderTangerine')({ theme: DENSE_LIGHT_THEME }),
    done: getToken('paletteBrandNight600')({ theme: DENSE_LIGHT_THEME }),
    online: getToken('legacyTagBorderLime')({ theme: DENSE_LIGHT_THEME }),
};

const getServiceStatistics = compose(get('serviceStatistics'), moduleSelector);
const getArrivals = compose(getOr(EMPTY, 'arrivals'), getServiceStatistics);
const getDepartures = compose(getOr(EMPTY, 'departures'), getServiceStatistics);

const getValueData =
    (dataKey: $TSFixMe) => (values: $TSFixMe, textKeys: $TSFixMe, colors: $TSFixMe, container: $TSFixMe) => {
        const getItem = get(dataKey);
        const color = getItem(colors);
        return (
            getItem(values) > 0 && {
                value: getItem(values),
                color,
                label: container().appLocalizationComponent.localizeText(getItem(textKeys)),
            }
        );
    };
const getServiceChartData = compose(
    compact,
    over([getValueData('toDo'), getValueData('missed'), getValueData('done'), getValueData('online')])
);

export const isLoaded = compose(get('isLoaded'), getServiceStatistics);
export const getLastModified = compose(getOr(0, 'lastModified'), getServiceStatistics);

export const getDeparturesStatistics = createSelector(
    getDepartures,
    () => DEPARTURE_KEYS,
    () => COLORS,
    getContainer,
    getServiceChartData
);

export const getArrivalsStatistics = createSelector(
    getArrivals,
    () => ARRIVAL_KEYS,
    () => COLORS,
    getContainer,
    getServiceChartData
);
